// @flow

import { type Country } from '@tectonics/prs/country';
import { type UserInputName } from '@tectonics/prs/user-input';
import {
  getTranslateErrorMessage,
  getRelatedInputNameFromError,
} from './error-messages';

export function mapUserInputError(errorCode: string, country: Country): [UserInputName, ?string] {
  const translateErrorMessage = getTranslateErrorMessage(country);
  const message = translateErrorMessage(errorCode);
  return [getRelatedInputNameFromError(errorCode, country), message];
}
